import React from 'react';
import EmptyList from '../../Components/EmptyList';

export default ({
  user,
  inspectors,
  activePage,
  rowsCount,
  sortedBy,
  listRequestInProcess,
  noEntrysForThisInspector,
}) => {
  const _getTextColourStyle = key => {
    if (sortedBy === key) return 'active';
    return '';
  };

  const _getBackgroundColourStyle = index => {
    return index % 2 ? '_background_color_pale_gray' : '_background_color_white';
  };

  const _getStatusColor = inspector => {
    return `list-scene__status-label_${inspector.active ? 'approved' : 'deactivated'}`;
  };

  function getTableBody() {
    if (noEntrysForThisInspector) {
      if (listRequestInProcess) {
        return (
          <div className='ect-spinner _height_120'>
            <div className='ect-spinner__image' style={{ width: 50, height: 50 }} />
          </div>
        );
      } else {
        return <EmptyList>No inspectors found for this role</EmptyList>;
      }
    } else if (!inspectors.length) {
      return <EmptyList>No inspectors found with selected search phrase.</EmptyList>;
    }

    const sliceFrom = (activePage - 1) * rowsCount;
    const sliceTo = rowsCount ? activePage * rowsCount : inspectors.length;
    return inspectors.slice(sliceFrom, sliceTo).map((inspector, index) => {
      return (
        <div
          id={`inspectorRowId${inspector.code}`}
          key={inspector.code}
          onClick={user.selectInspector(inspector)}
          className={`list-scene__table-row ${_getBackgroundColourStyle(index)}`}
        >
          <div className={`list-scene__status-bar_left ${_getStatusColor(inspector)}`} />

          <div
            id='inspectorCodeField'
            className={`list-scene__table-row-element
                           list-scene__table-row-element_text-element
                           ${_getTextColourStyle('code')}
                           _width_pc_12`}
          >
            {inspector.code}
          </div>

          <div
            id='inspectorNameField'
            className={`list-scene__table-row-element
          list-scene__table-row-element_place_filler
                           list-scene__table-row-element_text-element
                           ${_getTextColourStyle('name')}`}
          >
            {inspector.name}
          </div>

          <div className={`list-scene__status-bar_right ${_getStatusColor(inspector)}`} />
        </div>
      );
    });
  }

  return <div className='table-body'>{getTableBody()}</div>;
};



// WEBPACK FOOTER //
// ./src/app/Scenes/InspectorDashboardScene/TableBody.jsx